// created by khj1115 on 2021-07-26
import React from 'react';
import Layout from '@common/layout';
import Header from '@common/header';
import Content from '@common/content';
import Footer from '@common/footer';
import { InfoListCustomHead } from '@common/customHead';
import InfoList from '../../components/info/list/infoList';
import InfoWrapper from '../../components/info/list/infoWrapper';
import InfoListBanner from '../../components/info/list/infoListBanner';

const InfoListPage = () => {
  return (
    <Layout>
      <InfoListCustomHead />
      <Header />
      <Content>
        <InfoWrapper>
          <InfoListBanner />
          <InfoList />
        </InfoWrapper>
      </Content>
      <Footer />
    </Layout>
  );
};

export default InfoListPage;
